import administracao from '@/repositories/conecta-sus/administracao/index'
import almoxarifado from '@/repositories/conecta-sus/almoxarifado/index'
import ambulatorio from '@/repositories/conecta-sus/ambulatorio/index'
import atencaoBasica from '@/repositories/conecta-sus/atencao-basica/index'
import bpa from '@/repositories/conecta-sus/bpa/index'
import cadastro from '@/repositories/conecta-sus/cadastro/index'
import dashboard from './dashboardRepository'
import dataHora from '@/repositories/conecta-sus/dataHoraRepository'
import exameImagem from '@/repositories/conecta-sus/exame-imagem/index'
import exameLaboratorial from '@/repositories/conecta-sus/exame-laboratorial/index'
import exportacao from '@/repositories/conecta-sus/exportacao/index'
import farmacia from '@/repositories/conecta-sus/farmacia/index'
import geral from '@/repositories/conecta-sus/geralRepository'
import impressao from '@/repositories/conecta-sus/impressao/index'
import imunizacao from '@/repositories/conecta-sus/imunizacao/index'
import integracao from '@/repositories/conecta-sus/integracao/index'
import intranet from '@/repositories/conecta-sus/intranet/index'
import painelSenha from '@/repositories/conecta-sus/painel-senha/index'
import parametrizacao from '@/repositories/conecta-sus/parametrizacao/index'
import prontoAtendimento from '@/repositories/conecta-sus/pronto-atendimento/index'
import raas from '@/repositories/conecta-sus/raas/index'
import regulacao from '@/repositories/conecta-sus/regulacao/index'
import restPki from './restPkiRepository'
import sigtap from '@/repositories/conecta-sus/sigtap/index'
import transportePaciente from '@/repositories/conecta-sus/transporte-paciente/index'
import websocket from '@/repositories/conecta-sus/websocketRepository'

const baseUrl = ''
const baseUrlApi = `${baseUrl}/api`

export default ({
    administracao: administracao(baseUrlApi),
    almoxarifado: almoxarifado(baseUrlApi),
    ambulatorio: ambulatorio(baseUrlApi),
    atencaoBasica: atencaoBasica(baseUrlApi),
    bpa: bpa(baseUrlApi),
    cadastro: cadastro(baseUrlApi),
    dashboard: dashboard(baseUrlApi),
    dataHora: dataHora(baseUrlApi),
    exameImagem: exameImagem(baseUrlApi),
    exameLaboratorial: exameLaboratorial(baseUrlApi),
    exportacao: exportacao(baseUrl),
    farmacia: farmacia(baseUrlApi),
    geral: geral(baseUrlApi),
    impressao: impressao(baseUrl),
    imunizacao: imunizacao(baseUrlApi),
    integracao: integracao(baseUrlApi),
    intranet: intranet(baseUrlApi),
    painelSenha: painelSenha(baseUrlApi),
    parametrizacao: parametrizacao(baseUrlApi),
    prontoAtendimento: prontoAtendimento(baseUrlApi),
    raas: raas(baseUrlApi),
    regulacao: regulacao(baseUrlApi),
    restPki: restPki(baseUrlApi),
    sigtap: sigtap(baseUrlApi),
    transportePaciente: transportePaciente(baseUrlApi),
    websocket: websocket(baseUrlApi),
})